import { render, staticRenderFns } from "./registration-form.vue?vue&type=template&id=3d6e1bf1&scoped=true&"
import script from "./registration-form.ts?vue&type=script&lang=ts&"
export * from "./registration-form.ts?vue&type=script&lang=ts&"
import style0 from "./registration-form.scss?vue&type=style&index=0&id=3d6e1bf1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6e1bf1",
  null
  
)

export default component.exports